module.exports = __webpack_public_path__ + "img/D13-usa.19f0d6e2.png";